













































































































































































































































import { Component, Vue, Watch, Emit } from 'vue-property-decorator';
import { virtualMachineDetailsService } from './services/VirtualMachineDetailsService';
import PriceWithCurrency from '@/components/common/PriceWithCurrency.vue';

@Component({
  props: ['hardwareData', 'currentStats'],
  components: {
    PriceWithCurrency,
  },
})
export default class VirtualMachineHardwareSummary extends Vue {
  priceModifier = 0.00001;
  hoursInMonth = 730;
  sumChanges = 0;
  isCostChanged = false;
  overallCost = 0;
  isLimitExceeded = false;
  snapshotExists = false;
  limitReached: any = {
    cpu_cores: false,
    ram: false,
    storage: false,
  };
  isLoading = false;

  @Emit()
  resetParam(param: string) {
    return param;
  }

  @Emit()
  resetAdditionalDisk(index: string) {
    return index;
  }

  @Emit()
  removeAdditionalDisk(index: string) {
    return index;
  }

  @Emit()
  saveData() {
    return;
  }

  @Watch('$props.currentStats', { immediate: true, deep: true })
  onStatsChange() {
    this.isCostChanged = false;
    const current = this.$props.currentStats;
    const hardware = this.$props.hardwareData;
    if (!current || !hardware || !current.cpu_cores || !hardware.resources.cpu) {
      return;
    }
    this.sumChanges = 0;
    if ((current.cpu_cores || 0) - hardware.cpu_cores !== 0 && current.cpu_cores >= 1) {
      this.isCostChanged = true;
    }
    if ((current.ram || 0) - hardware.ram !== 0 && current.ram >= 1) {
      this.isCostChanged = true;
    }
    this.sumChanges +=
      (current.cpu_cores - hardware.cpu_cores) * hardware.resources.cpu.price.cents * this.priceModifier;
    this.sumChanges += (current.ram - hardware.ram) * hardware.resources.ram.price.cents * this.priceModifier;
    if (current.primary_disk.size - hardware.primary_disk.size > 0) {
      this.sumChanges +=
        (current.primary_disk.size - hardware.primary_disk.size) *
        hardware.resources.primary_disk.price.cents *
        this.priceModifier;
      this.isCostChanged = true;
    }
    hardware.additional_disks.map((item: any, index: number) => {
      if (current.additional_disks[index].size - item.size > 0 || current.additional_disks[index].size === 0) {
        this.isCostChanged = true;
        if (current.additional_disks[index].type === 'hdd') {
          this.sumChanges +=
            (current.additional_disks[index].size - item.size) *
            hardware.resources.additional_disk.price.hdd.cents *
            this.priceModifier;
        } else {
          this.sumChanges +=
            (current.additional_disks[index].size - item.size) *
            hardware.resources.additional_disk.price.ssd.cents *
            this.priceModifier;
        }
      }
    });
    this.overallCost = hardware.current_cost.cents * this.priceModifier + this.sumChanges;
  }
  closeModal() {
    this.isLimitExceeded = false;
    this.snapshotExists = false;
  }
  save() {
    this.snapshotExists = false;
    const workspaceId = parseInt(this.$route.params.workspaceId, 10);
    const regionId = parseInt(this.$route.params.regionId, 10);
    const virtualMachineId = parseInt(this.$route.params.virtualMachineId, 10);
    const payload = JSON.parse(JSON.stringify(this.$props.currentStats));
    payload.additional_disks = payload.additional_disks.map((item: any) => {
      if (item.isNew) {
        item.id = null;
        delete item.isNew;
      }
      return item;
    });
    payload.additional_disks = payload.additional_disks.filter((item: any) => !!item.size);
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    virtualMachineDetailsService
      .updateHardware(workspaceId, regionId, virtualMachineId, payload)
      .then(() => {
        this.isLoading = false;
        this.saveData();
      })
      .catch((data: any) => {
        this.isLoading = false;
        if (data && data.data && data.status === 422) {
          let error = data.data.error || {};
          if (error.cpu_cores && error.cpu_cores[0] && error.cpu_cores[0].error === 'limit_reached') {
            this.isLimitExceeded = true;
            this.limitReached.cpu_cores = true;
          }
          if (error.ram && error.ram[0] && error.ram[0].error === 'limit_reached') {
            this.isLimitExceeded = true;
            this.limitReached.ram = true;
          }
          if (error.storage && error.storage[0] && error.storage[0].error === 'limit_reached') {
            this.isLimitExceeded = true;
            this.limitReached.storage = true;
          }
        }
        if (data && data.data && data.status === 403 && data.data.error === 'snapshot_exists') {
          this.snapshotExists = true;
        }
      });
  }
}
